import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';
import { toInteger } from 'lodash';

export const fjJobsApi = createApi({
  reducerPath: 'fjJobsApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    // Endpoint pre list vsetkych ponuk prace (CMS)
    getFjJobs: builder.query({
      query: () => ({
        url: urls.friJobsJobs,
      }),
    }),
    GetFjInterested: builder.query({
      query: (id) => ({
        url: urls.friJobsInterested(id),
      }),
    }),
    // Endpoint pre list vsetkych ponuk prace (Public)
    getFjPublicJobs: builder.query({
      query: () => ({
        url: urls.friJobsPublicJobs,
      }),
    }),
    // Endpoint pre nacitanie konkretnej ponuky prace (CMS)
    getFjJob: builder.query({
      query: (id) => ({
        url: urls.friJobsJobDetail(id),
      }),
    }),
    // Endpoint pre nacitanie konkretnej ponuky prace (Public)
    getFjPublicJob: builder.query({
      query: (id) => ({
        url: urls.friJobsPublicJobDetail(id),
      }),
    }),
    // Endpoint pre schvalenie ponuky prace
    approveFjJob: builder.mutation({
      query(id) {
        return {
          url: urls.friJobsJobApprove(id),
          method: 'PUT',
        };
      },
    }),
    // Endpoint pre zamietnutie ponuky prace
    disapproveFjJob: builder.mutation({
      query(id) {
        return {
          url: urls.friJobsJobDisapprove(id),
          method: 'PUT',
        };
      },
    }),
    // Endpoint pre archivovanie ponuky prace
    archiveFjJob: builder.mutation({
      query(id) {
        return {
          url: urls.friJobsJobsArchive(id),
          method: 'PUT',
        };
      },
    }),
    // Ednpoint pre ulozenie novej ponuky prace
    saveFjJob: builder.mutation({
      query(req) {
        if (req.id) {
          return {
            url: urls.friJobsJobDetail(req.id),
            method: 'PUT',
            data: req,
          };
        } else {
          return {
            url: urls.friJobsJobs,
            method: 'POST',
            data: req,
          };
        }
      },
    }),
    // Endpoint pre zmazanie ponuky prace
    deleteFjJob: builder.mutation({
      query(id) {
        return {
          url: urls.friJobsJobsDelete(id),
          method: 'DELETE',
        };
      },
    }),
  }),
});

export const {
  useGetFjJobsQuery,
  useGetFjPublicJobsQuery,
  useGetFjInterestedQuery,
  useGetFjJobQuery,
  useGetFjPublicJobQuery,
  useApproveFjJobMutation,
  useDisapproveFjJobMutation,
  useArchiveFjJobMutation,
  useSaveFjJobMutation,
  useDeleteFjJobMutation,
} = fjJobsApi;
